import axios from 'axios'

const TRANSPARENT_1PX_PNG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

function createFileReaderAsyncContext (action)
{
    return new Promise((resolve, reject) =>
    {
        const fileReader = new FileReader()
        fileReader.onload = () =>
        {
            let result = fileReader.result
            if (!result || result == 'data:')
            {
                console.error('Could not load file, providing 1x1 transparent png.')
                result = TRANSPARENT_1PX_PNG
            }

            resolve(result)
        }

        fileReader.onerror = reject

        action(fileReader)
    })
}

function readAsDataURLAsync (file)
{
    return createFileReaderAsyncContext(reader => reader.readAsDataURL(file))
}

function readAsTextAsync (file)
{
    return createFileReaderAsyncContext(reader => reader.readAsText(file))
}

function readAsArrayBufferAsync (file)
{
    return createFileReaderAsyncContext(reader => reader.readAsArrayBuffer(file))
}

async function srcToBlobAsync (src)
{
    let response

    try
    {
        response = await axios.get(src, { responseType: 'blob' })
    }
    catch (e)
    {
        console.error(e)
        
        return new Blob()
    }

    return new Blob([response.data], { type: response.data.type })
}

async function srcToDataUrlAsync (src)
{
    return readAsDataURLAsync(await srcToBlobAsync(src))
}

export default { readAsDataURLAsync, srcToBlobAsync, srcToDataUrlAsync, readAsTextAsync, readAsArrayBufferAsync }


// WEBPACK FOOTER //
// ./src/utils/fileReaderUtils.js